<template>
  <v-container class="login" fill-height d-flex justify-center fluid>
    <v-card :width="600" class="login-card elevation-2">
      <v-card-title class="d-flex justify-center">
        <img
          src="@/assets/digita-logo-dark.png"
          class="py-4"
          style="max-width: 150px"
        />
      </v-card-title>
      <v-card-text>
        <v-form v-model="formValid" @submit.prevent>
          <v-text-field
            v-model="form.email"
            required
            outlined
            type="email"
            placeholder="Email address"
            background-color="shades white"
            :rules="$rules.email"
          ></v-text-field>
          <v-text-field
            v-model="form.password"
            required
            outlined
            type="password"
            placeholder="Password"
            background-color="shades white"
            :rules="$rules.password"
          ></v-text-field>
          <v-btn
            block
            color="primary"
            x-large
            dark
            :disabled="!formValid"
            type="submit"
            @click="login"
          >
            {{ $t('Login') }}
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<style lang="sass">
@import '@/scss/variables.scss'
.login
  background-color: map-get($digita, 'grey')
  .login-card
    background: linear-gradient(#3B424E, #22262B)
</style>
<script>
import FormMixin from '@/mixins/FormMixin'

export default {
  mixins: [FormMixin],

  data: () => ({
    form: {
      email: null,
      password: null
    },
    formValid: false
  }),

  methods: {
    async login() {
      let me = this

      try {
        me.$debug('login', me.form.email)
        await me.$store.dispatch('user/login', me.form)
      } catch (err) {
        me.$error(err)
      }
    }
  }
}
</script>
